"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-sixteen/section/chooseUsSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type ChooseUsSection46sItem = {
    key: Key | null | undefined;
    /** Detected variants: "1s" | "1.5s" | "2s" | "2.5s" | "3s" | "3.5s" */
    dataWowDuration: string;
    /** Detected variants: "/Templates/Doccure/img/icons/choose-icon-8.svg" | "/Templates/Doccure/img/icons/choose-icon-9.svg" | "/Templates/Doccure/img/icons/choose-icon-10.svg" | "/Templates/Doccure/img/icons/choose-icon-11.svg" | "/Templates/Doccure/img/icons/choose-icon-12.svg" | "/Templates/Doccure/img/icons/choose-icon-13.svg" */
    src: string;
    /** Detected variants: "Progress Tracking" | "Flexible Scheduling" | "24/7 Support Chat" | "Evidence Based" | "Certified Experts" | "Mobile App Access" */
    h30Text: ReactNode;
    /** Detected variants: "Visualize your journey with detailed analytics, body composition tracking, and milestone celebrations." | "Book consultations at times that work for you, with same-day appointments and virtual sessions available." | "Get answers to your questions instantly with unlimited messaging to your dedicated wellness team." | "All recommendations backed by peer-reviewed research and approved by registered dietitians." | "Work with nationally certified dietitians and wellness coaches with advanced practice & credentials." | "Track meals, log progress, and access your personalized plan anytime, anywhere with our intuitive mobile app." */
    p0Text: ReactNode;
    /** Detected variants: "col-lg-4 col-sm-6 d-flex" */
    className?: string;
    /** Detected variants: "choose-item-sixteen flex-fill wow fadeInUp" */
    div0ClassName?: string;
    /** Detected variants: "choose-icon" */
    div0ClassName2?: string;
    /** Detected variants: "choose-img-6" */
    alt?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "choose-content" */
    div1ClassName?: string;
    /** Detected variants: "choose-title" */
    h30ClassName?: string;
    /** Detected variants: "description" */
    p0ClassName?: string;
};
export type HomeSixteenChooseUsSectionGeneratedProps = {
    divDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ChooseUsSection46sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: ChooseUsSection46sItem) => Partial<ComponentProps<"h3">>);
    /** Default: "1s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "Why Choose Us" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "Comprehensive tools and support" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "designed for" */
    sectionDiv0Div0H20Span0SpanText?: ReactNode;
    /** Default: "your transformation journey" */
    sectionDiv0Div0H20Span0SpanText2?: ReactNode;
    sectionDiv0Div1ClassName?: string;
    /** Default: "img" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/choose-img-1.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "img" */
    sectionImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/choose-img-2.png" */
    sectionImageWithBasePath1ImageSrc?: string;
    sectionImageWithBasePath1ImageVisible?: boolean;
    sectionImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    chooseUsSection46s: ChooseUsSection46sItem[];
    chooseUsSection46sItemWrapper?: (item: ChooseUsSection46sItem, content: ReactNode) => ReactNode;
    chooseUsSection46sRenderer?: (defaultNode: ReactNode) => ReactNode;
    chooseUsSection46sImageVisible?: boolean;
    chooseUsSection46sImageRenderer?: (item: ChooseUsSection46sItem, defaultNode: ReactNode) => ReactNode;
    chooseUsSection46sH3Visible?: boolean;
    chooseUsSection46sH3Renderer?: (item: ChooseUsSection46sItem, defaultNode: ReactNode) => ReactNode;
    chooseUsSection46sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ChooseUsSection46sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    chooseUsSection46sH3Props?: Partial<ComponentProps<"h3">> | ((item: ChooseUsSection46sItem) => Partial<ComponentProps<"h3">>);
};

const HomeSixteenChooseUsSectionGenerated: FC<HomeSixteenChooseUsSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "Why Choose Us",
    sectionDiv0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0H20H2Text = "Comprehensive tools and support",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0H20Span0SpanText = "designed for",
    sectionDiv0Div0H20Span0SpanText2 = "your transformation journey",
    sectionImageWithBasePath0ImageAlt = "img",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/choose-img-1.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    sectionImageWithBasePath1ImageAlt = "img",
    sectionImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/choose-img-2.png",
    sectionImageWithBasePath1ImageVisible,
    sectionImageWithBasePath1ImageRenderer,
    sectionImageWithBasePath1ImageProps,
    divDiv0Div0ImageWithBasePath0ImageProps,
    divDiv0Div1H30H3Props,
    sectionDiv0Div1ClassName,
    chooseUsSection46s,
    chooseUsSection46sItemWrapper,
    chooseUsSection46sRenderer,
    chooseUsSection46sImageVisible,
    chooseUsSection46sImageRenderer,
    chooseUsSection46sH3Visible,
    chooseUsSection46sH3Renderer,
    chooseUsSection46sImageProps,
    chooseUsSection46sH3Props,
}) => {
    return (
        <section className="section whychoose-section-sixteen">
            <div className="container">
                <div className="section-header-sixteen wow fadeInDown" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                    <div className="sub-title">{sectionDiv0Div0Div0DivText}</div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {sectionDiv0Div0H20H2Text}
                            {" "}
                            <span>
                                {sectionDiv0Div0H20Span0SpanText}
                                <br />
                                {sectionDiv0Div0H20Span0SpanText2}
                                {" "}
                            </span>
                        </h2>
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row row-gap-4"}>
                    {renderCollectionNode(
                        chooseUsSection46s,
                        (item: ChooseUsSection46sItem) => (
                            <div className={item.className ?? "col-lg-4 col-sm-6 d-flex"} key={item.key}>
                                <div className={item.div0ClassName ?? "choose-item-sixteen flex-fill wow fadeInUp"} data-wow-duration={item.dataWowDuration}>
                                    <div className={item.div0ClassName2 ?? "choose-icon"}>
                                        {renderItemNode(chooseUsSection46sImageVisible, chooseUsSection46sImageRenderer, item, (
                                            <SmartImage src={item.src} alt={item.alt ?? "choose-img-6"} className={item.imageWithBasePath0ClassName ?? "img-fluid"} {...(typeof chooseUsSection46sImageProps === "function" ? chooseUsSection46sImageProps(item) : (chooseUsSection46sImageProps ?? {}))} {...(typeof divDiv0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                        ))}
                                    </div>
                                    <div className={item.div1ClassName ?? "choose-content"}>
                                        {renderItemNode(chooseUsSection46sH3Visible, chooseUsSection46sH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "choose-title"} {...(typeof chooseUsSection46sH3Props === "function" ? chooseUsSection46sH3Props(item) : (chooseUsSection46sH3Props ?? {}))} {...(typeof divDiv0Div1H30H3Props === "function" ? divDiv0Div1H30H3Props(item) : (divDiv0Div1H30H3Props ?? {}))}>{item.h30Text}</h3>
                                        ))}
                                        <p className={item.p0ClassName ?? "description"}>{item.p0Text}</p>
                                    </div>
                                </div>
                            </div>
                        ),
                        chooseUsSection46sItemWrapper,
                        chooseUsSection46sRenderer
                    )}
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid element-one d-none d-sm-block" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath1ImageVisible, sectionImageWithBasePath1ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath1ImageSrc} alt={sectionImageWithBasePath1ImageAlt} className="img-fluid element-two d-none d-sm-block" {...(sectionImageWithBasePath1ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeSixteenChooseUsSectionGenerated;
